import React from "react";
import { revokeAsset } from "../../helpers/apiHelper";
import Dialog from "./Dialog";
import { DerivedDialogProps } from "../../types/dialogTypes";
import { AssetStatus } from "../../types/statusTypes";

interface RevokeDialogProps extends DerivedDialogProps {
  assetStatus: AssetStatus;
}

export default function RevokeDialog(
  { assetId, assetStatus, onSuccess, onFailure }: RevokeDialogProps,
) {
  function getAlertText(error: string) {
    return `Revoke failed, please try again. Error: ${error}`;
  }

  let headerText, body, submitText;

  switch (assetStatus) {
    case AssetStatus.Active:
      headerText = "Revoke Asset";
      body = `Would you like to revoke content with ID ${assetId}?`;
      submitText = "Revoke";
      break;
    case AssetStatus.RevokeFailed:
      headerText = "Retry Revoke";
      body = `Would you like to try to revoke content with ID ${assetId} again?`;
      submitText = "Revoke";
      break;
    case AssetStatus.Revoked:
      headerText = "Revoke Unavailable";
      body = "This asset has already been revoked.";
      submitText = undefined;
  }

  return (
    <Dialog
      id="revoke-modal"
      headerText={headerText}
      body={body}
      submitText={submitText}
      onSubmit={() => revokeAsset(assetId)}
      onSuccess={onSuccess}
      onFailure={error => onFailure && onFailure(getAlertText(error))}
    />
  );
}
